<template>
  <span class="purchasing-unit-label">
    <span>{{ label }}</span>
    <b-tag v-if="statusLabel" size="is-small" :type="statusType" class="ml-1">{{
      statusLabel
    }}</b-tag>
  </span>
</template>

<script>
export default {
  name: 'PurchasingUnitLabel',
  props: { unit: { type: Object, default: null } },
  computed: {
    label() {
      if (!this.unit) return 'Unidade não definida';
      return [this.unit.code, this.unit.name].filter(Boolean).join(' — ') || 'Unidade não definida';
    },
    statusLabel() {
      const labels = {
        INACTIVE: 'Inativa',
        INATIVA: 'Inativa',
        CANCELADO: 'Cancelada',
        PENDING: 'Sincronização pendente',
        PENDENTE: 'Sincronização pendente',
        PROCESSING: 'Sincronizando',
        PROCESSANDO: 'Sincronizando',
        ERROR: 'Erro de sincronização',
        ERRO: 'Erro de sincronização',
      };
      return [labels[this.unit?.status], labels[this.unit?.syncStatus]]
        .filter(Boolean)
        .filter((value, index, values) => values.indexOf(value) === index)
        .join(' · ');
    },
    statusType() {
      return this.statusLabel.includes('Erro') || this.statusLabel.includes('Cancelada')
        ? 'is-danger'
        : 'is-warning';
    },
  },
};
</script>
